import { render, staticRenderFns } from "./AssetsTable.vue?vue&type=template&id=fe55232e"
import script from "./AssetsTable.vue?vue&type=script&lang=js"
export * from "./AssetsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports